module.exports = __webpack_public_path__ + "static/media/funnel-tutorial-5-step1.6888b915.svg";